import React, { useState } from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import { motion } from "framer-motion";

function Cart() {
  const [checked, setChecked] = useState(false);

  console.log(checked);

  return (
    <div className="text-black w-full bg-secondary min-h-screen flex flex-col items-center gap-4">
      <div className="h-[8vh] bg-black w-full"></div>
      <div className="min-h-screen w-11/12 md:w-10/12 py-2 mb-16 flex flex-col gap-8">
        <Link
          to="/"
          className="w-max text-xs font-bold tracking-wide text-black/60 hover:text-black"
        >
          GO BACK
        </Link>
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          className="grid md:grid-cols-6 gap-8"
        >
          <div className="md:col-span-4 h-max flex flex-col gap-8 items-center bg-white rounded-lg p-4 md:p-8">
            <p className="w-full text-3xl font-bold uppercase">CHECKOUT</p>
            <div className="w-full flex flex-col gap-3">
              <p className="text-[10px] font-bold tracking-widest uppercase text-primary">
                Billing Details
              </p>
              <div className="grid sm:grid-cols-2 gap-3">
                <div className="flex flex-col gap-1 capitalize">
                  <label className="text-xs font-bold capitalize">Name</label>
                  <input className="bg-transparent border-[1.5px] border-black/30 text-xs font-medium rounded-lg p-3 outline-none outline-0" />
                </div>
                <div className="flex flex-col gap-1 capitalize">
                  <label className="text-xs font-bold">Email address</label>
                  <input className="bg-transparent border-[1.5px] border-black/30 text-xs font-medium rounded-lg p-3 outline-none outline-0" />
                </div>
                <div className="flex flex-col gap-1 capitalize">
                  <label className="text-xs font-bold">Phone number</label>
                  <input className="bg-transparent border-[1.5px] border-black/30 text-xs font-medium rounded-lg p-3 outline-none outline-0" />
                </div>
              </div>
            </div>
            <div className="w-full flex flex-col gap-3">
              <p className="text-[10px] font-bold tracking-widest uppercase text-primary">
                Shipping Info
              </p>
              <div className="grid grid-cols-2 gap-3">
                <div className="flex flex-col gap-1 capitalize col-span-2">
                  <label className="text-xs font-bold capitalize">Adress</label>
                  <input className="bg-transparent border-[1.5px] border-black/30 text-xs font-medium rounded-lg p-3 outline-none outline-0" />
                </div>
                <div className="flex flex-col gap-1 capitalize">
                  <label className="text-xs font-bold">Zip Code</label>
                  <input className="bg-transparent border-[1.5px] border-black/30 text-xs font-medium rounded-lg p-3 outline-none outline-0" />
                </div>
                <div className="flex flex-col gap-1 capitalize">
                  <label className="text-xs font-bold">City</label>
                  <input className="bg-transparent border-[1.5px] border-black/30 text-xs font-medium rounded-lg p-3 outline-none outline-0" />
                </div>
                <div className="flex flex-col gap-1 capitalize md:col-span-1 col-span-2">
                  <label className="text-xs font-bold">Country</label>
                  <input className="bg-transparent border-[1.5px] border-black/30 text-xs font-medium rounded-lg p-3 outline-none outline-0" />
                </div>
              </div>
            </div>
            <div className="w-full flex flex-col gap-3">
              <p className="text-[10px] font-bold tracking-widest uppercase text-primary">
                Payment Details
              </p>
              <div className="grid gap-3 gap-y-6 grid-cols-2">
                <div className="flex flex-col gap-1 col-span-2">
                  <label className="text-xs font-bold capitalize">Name</label>
                  <form className="grid grid-cols-2 gap-3 w-full">
                    <div className="bg-transparent border-[1.5px] border-black/30 text-xs flex items-center gap-4 font-medium rounded-lg p-3 outline-none outline-0">
                      <input
                        onChange={() => setChecked(true)}
                        type="radio"
                        name="payment"
                        className="bg-transparent border-[1.5px] border-black/30 text-xs font-medium rounded-lg p-3 outline-none outline-0"
                      />
                      <p className="text-xs font-semibold">e-Money</p>
                    </div>
                    <div className="bg-transparent border-[1.5px] border-black/30 text-xs flex items-center gap-4 font-medium rounded-lg p-3 outline-none outline-0">
                      <input
                        onChange={() => setChecked(false)}
                        type="radio"
                        name="payment"
                        className="bg-transparent border-[1.5px] border-black/30 text-xs font-medium rounded-lg p-3 outline-none outline-0"
                      />
                      <p className="text-xs font-semibold">Cash on Delivery</p>
                    </div>
                  </form>
                </div>
                {checked && (
                  <>
                    <div className="flex flex-col gap-1">
                      <label className="text-xs font-bold">
                        e-Money Number
                      </label>
                      <input className="bg-transparent border-[1.5px] border-black/30 text-xs font-medium rounded-lg p-3 outline-none outline-0" />
                    </div>
                    <div className="flex flex-col gap-1">
                      <label className="text-xs font-bold">e-Money PIN</label>
                      <input className="bg-transparent border-[1.5px] border-black/30 text-xs font-medium rounded-lg p-3 outline-none outline-0" />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="md:col-span-2 flex flex-col gap-8 items-center bg-white h-max rounded-lg p-4 md:p-8">
            <p className="w-full text-sm font-bold uppercase">Summary</p>
            <div className="flex flex-col gap-3 w-full overflow-auto pb-2 inner-shadow max-h-[300px]">
              <div className="flex items-center gap-3">
                <div className="h-14 w-14 p-1 shadow grid place-items-center overflow-hidden bg-secondary rounded-md">
                  <img
                    alt=""
                    className="w-full h-full"
                    src="https://i.ibb.co/xmhPxfW/hps.png"
                  />
                </div>
                <div className="flex justify-between flex-1 items-start">
                  <div className="flex flex-col gap-0.5">
                    <p className="text-sm font-bold">XX99 MARK II</p>
                    <p className="text-xs font-bold text-black/70">$ 2,999</p>
                  </div>
                  <p className="text-sm font-bold text-black/50">x1</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="h-14 w-14 p-1 shadow grid place-items-center overflow-hidden bg-secondary rounded-md">
                  <img
                    alt=""
                    className="w-full h-full"
                    src="https://i.ibb.co/xmhPxfW/hps.png"
                  />
                </div>
                <div className="flex justify-between flex-1 items-start">
                  <div className="flex flex-col gap-0.5">
                    <p className="text-sm font-bold">XX99 MARK II</p>
                    <p className="text-xs font-bold text-black/70">$ 2,999</p>
                  </div>
                  <p className="text-sm font-bold text-black/50">x1</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="h-14 w-14 p-1 shadow grid place-items-center overflow-hidden bg-secondary rounded-md">
                  <img
                    alt=""
                    className="w-full h-full"
                    src="https://i.ibb.co/xmhPxfW/hps.png"
                  />
                </div>
                <div className="flex justify-between flex-1 items-start">
                  <div className="flex flex-col gap-0.5">
                    <p className="text-sm font-bold">XX99 MARK II</p>
                    <p className="text-xs font-bold text-black/70">$ 2,999</p>
                  </div>
                  <p className="text-sm font-bold text-black/50">x1</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="h-14 w-14 p-1 shadow grid place-items-center overflow-hidden bg-secondary rounded-md">
                  <img
                    alt=""
                    className="w-full h-full"
                    src="https://i.ibb.co/xmhPxfW/hps.png"
                  />
                </div>
                <div className="flex justify-between flex-1 items-start">
                  <div className="flex flex-col gap-0.5">
                    <p className="text-sm font-bold">XX99 MARK II</p>
                    <p className="text-xs font-bold text-black/70">$ 2,999</p>
                  </div>
                  <p className="text-sm font-bold text-black/50">x1</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="h-14 w-14 p-1 shadow grid place-items-center overflow-hidden bg-secondary rounded-md">
                  <img
                    alt=""
                    className="w-full h-full"
                    src="https://i.ibb.co/xmhPxfW/hps.png"
                  />
                </div>
                <div className="flex justify-between flex-1 items-start">
                  <div className="flex flex-col gap-0.5">
                    <p className="text-sm font-bold">XX99 MARK II</p>
                    <p className="text-xs font-bold text-black/70">$ 2,999</p>
                  </div>
                  <p className="text-sm font-bold text-black/50">x1</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="h-14 w-14 p-1 shadow grid place-items-center overflow-hidden bg-secondary rounded-md">
                  <img
                    alt=""
                    className="w-full h-full"
                    src="https://i.ibb.co/xmhPxfW/hps.png"
                  />
                </div>
                <div className="flex justify-between flex-1 items-start">
                  <div className="flex flex-col gap-0.5">
                    <p className="text-sm font-bold">XX99 MARK II</p>
                    <p className="text-xs font-bold text-black/70">$ 2,999</p>
                  </div>
                  <p className="text-sm font-bold text-black/50">x1</p>
                </div>
              </div>
            </div>
            <div className="w-full flex flex-col gap-2">
              <div className="flex items-center justify-between">
                <p className="text-sm font-semibold text-black/60">Total</p>
                <p className="text-sm font-bold text-black">$ 3,000</p>
              </div>
              <div className="flex items-center justify-between">
                <p className="text-sm font-semibold text-black/60">Shipping</p>
                <p className="text-sm font-bold text-black">$ 300</p>
              </div>
              <div className="flex items-center justify-between">
                <p className="text-sm font-semibold text-black/60">
                  VAT (Included)
                </p>
                <p className="text-sm font-bold text-black">$ 40</p>
              </div>
              <div className="flex items-center justify-between mt-2">
                <p className="text-sm font-semibold text-black/60">
                  Grand Total
                </p>
                <p className="text-sm font-bold text-black">$ 5,640</p>
              </div>
            </div>
            <button className="bg-primary w-full hover:bg-white text-white border border-primary hover:text-primary shadow-lg text-xs px-6 py-3 font-semibold uppercase tracking-wide">
              CONTINUE & PAY
            </button>
          </div>
        </motion.div>
      </div>
      <Footer />
    </div>
  );
}

export default Cart;
